import React from 'react';
import PropTypes from 'prop-types';
import InputValidator from '../common/InputValidator.jsx';
import ValidatedComponent from '../common/ValidatedComponent.jsx';

class ChangeEmail extends React.Component {
  constructor() {
    super();

    this.state = {
      newEmail: ''
    };
  }

  render() {
    const {newEmail} = this.state;
    const {email, errors, savedNewEmail, isNewEmailConfirmed} = this.props;

    const isConfirmationPending = !!savedNewEmail && !isNewEmailConfirmed;
    const isVerificationPending = !!savedNewEmail && isNewEmailConfirmed;
    const isChangeRequested = !!savedNewEmail;

    return (
      <div>
        <div className="row ba-profile-panel">
          <div className="small-12 columns">
            <h2>Change Account Email</h2>
          </div>
          {!isChangeRequested ?
            <div className="small-12 columns">
              <InputValidator fieldName="New email"
                              errors={errors.newEmail}>
                <input type="email"
                       value={newEmail}
                       required
                       placeholder="New email"
                       onChange={e => this.setState({newEmail: e.target.value})}/>
              </InputValidator>
            </div>
            : null
          }
          <div className="small-12 columns">
            {
              !isChangeRequested ?
                <button type="button"
                        onClick={this.onChangeEmailClick.bind(this)}
                        className="button ba-default-btn">
                  Change email
                </button>
                :
                null
            }
            {
              isConfirmationPending ?
                <div>
                  <p>You requested to change email to <b>{savedNewEmail}</b>.
                    Please continue with the confirmation email sent to <b>{email}</b>.</p>
                  <button type="button"
                          onClick={this.props.onResendConfirmationEmail}
                          className="button ba-default-btn">
                    Resend confirmation email
                  </button>
                </div>
                :
                null
            }
            {
              isVerificationPending ?
                <div>
                  <p>A verification email has been sent to the new email address (<b>{savedNewEmail}</b>).</p>
                  <button type="button"
                          onClick={this.props.onResendVerificationEmail}
                          className="button ba-default-btn">
                    Resend verification email
                  </button>
                </div>
                :
                null
            }
            {
              isChangeRequested ?
                <div>
                  <p>Your current email is <b>{email}</b></p>
                  <button type="button"
                          onClick={this.props.onCancelChangeEmail}
                          className="button ba-default-btn">
                    Cancel change request
                  </button>
                </div>
                :
                null
            }
          </div>
        </div>
      </div>
    );
  }

  onChangeEmailClick() {
    if (this.context.isComponentValid()) {
      const {newEmail} = this.state;
      this.props.onChangeEmail(newEmail);
    }
  }
}

ChangeEmail.displayName = 'ChangeEmail';
ChangeEmail.propTypes = {
  errors: PropTypes.object,
  email: PropTypes.string.isRequired,
  savedNewEmail: PropTypes.string,
  isNewEmailConfirmed: PropTypes.bool,
  onChangeEmail: PropTypes.func.isRequired,
  onCancelChangeEmail: PropTypes.func.isRequired,
  onResendConfirmationEmail: PropTypes.func.isRequired,
  onResendVerificationEmail: PropTypes.func.isRequired
};

export default ValidatedComponent(ChangeEmail);


// WEBPACK FOOTER //
// ./shared/profile/ChangeEmail.jsx